import React, { useContext, useState } from "react";
import { AuthFetch } from "../../services/api";
import { UserContext } from "../../context/provider/UserProvider";
import { notify } from "../../utils/utils";


const urlBaseSettings = process.env.REACT_APP_TMAN_API + '/Setting'

export const useSettings = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa

    const [conductores,setConductores] = useState([])
    const [tipoMonedas,setTipoMonedas] = useState([])
    
    const listarConductores = async () => {
        const response = await AuthFetch({
            url: urlBaseSettings + '/drivers?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setConductores(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarTipoMoneda = async () => {
        const response = await AuthFetch({
            url: urlBaseSettings + '/currencyType?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setTipoMonedas(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }
    
    return {
        listarConductores,
        conductores,
        listarTipoMoneda,
        tipoMonedas
    }
};
